import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { GetActiveCaseTypesResult } from './get-active-case-types.result';

@Injectable({ providedIn: 'root' })
export class GetActiveCaseTypesUseCase {
  private readonly _caseTypeRepository = inject(CaseTypeRepository);

  public execute(): Observable<GetActiveCaseTypesResult> {
    return this._caseTypeRepository.getActiveCaseTypes().pipe(map((caseTypes) => ({ caseTypes })));
  }
}
